import { ApiUrl } from "../framework/network/api-url";
import { UrlActionName as UA, UrlClassName as UC } from "./url-name";

export class ApiUrlPath {
    static readonly userAdd = ApiUrl.v1(UC.user, UA.insert);
    static readonly userUpdate = ApiUrl.v1(UC.user, UA.update);
    static readonly userGet = ApiUrl.v1(UC.user, UA.get);
    static readonly userGetAll = ApiUrl.v1(UC.user, UC.script, UA.get);
    static readonly userAddPoll = ApiUrl.v1(UC.user, UC.poll, UA.insert);
    static readonly userGetPolls = ApiUrl.v1(UC.user, UC.poll, UA.get);
    static readonly userSetPlayerId = ApiUrl.v1(UC.user, UC.oneSignal, UA.insert);
    static readonly userGeoIp = ApiUrl.v1(UC.user, UC.geoIp, UA.get);
    static readonly removePlayerId = ApiUrl.v1(UC.user, UC.oneSignal, UA.delete);
    static readonly userFirebaseAuth = ApiUrl.v1(UC.user, UC.firebase, UC.auth, UA.insert);
    static readonly userFollow = ApiUrl.v1(UC.user, UA.follow);
    static readonly userUnfollow = ApiUrl.v1(UC.user, UA.unfollow);
    static readonly userFirebaseCheckPhone = ApiUrl.v1(
        UC.user,
        UC.firebase,
        UC.auth,
        UA.checkPhone
    );

    static readonly pollGet = ApiUrl.v1(UC.poll, UA.get);
    static readonly pollGetById = ApiUrl.v1(UC.poll, UA.fetch);
    static readonly pollCollectionGet = ApiUrl.v1(UC.poll, UC.pollQuestionCollection, UA.get);
    static readonly pollImageCollectionGet = ApiUrl.v1(UC.poll, UC.pollImageCollection, UA.get);

    static readonly pollAdd = ApiUrl.v1(UC.poll, UA.insert);
    static readonly pollDelete = ApiUrl.v1(UC.poll, UA.delete);
    static readonly pollTrack = ApiUrl.v1(UC.poll, UA.track);
    static readonly pollImpressionAdd = ApiUrl.v1(UC.poll, UC.pollImpression, UA.insert);

    static readonly commentAdd = ApiUrl.v1(UC.poll, UC.comment, UA.insert);
    static readonly commentList = ApiUrl.v1(UC.poll, UC.comment, UA.get);

    static readonly pollVoteAdd = ApiUrl.v1(UC.poll, UC.pollVote, UA.insert);
    static readonly pollResultGet = ApiUrl.v1(UC.poll, UC.pollVote, UC.result, UA.get);

    static readonly categoryGet = ApiUrl.v1(UC.category, UC.category, UA.get);

    static readonly fileUpload = ApiUrl.v1(UC.common, UC.s3File, UA.insert);
    //script
    static readonly scriptPollGet = ApiUrl.v1(UC.poll, UC.script, UA.get);
    static readonly scriptPollVoteGet = ApiUrl.v1(UC.poll, UC.pollVote, UC.script, UA.get);
    static readonly scriptPollBotVote = ApiUrl.v1(UC.poll, UC.pollVote, UC.script, UA.insert);
    static readonly scriptPollUpdate = ApiUrl.v1(UC.poll, UC.poll, UC.script, UA.update);
    static readonly bootUserAdd = ApiUrl.v1(UC.user, UC.script, UA.insert);
    static readonly notificationAdd = ApiUrl.v1(UC.notification, UC.notification, UA.insert);
    // Webhooks
    static readonly msg91Webhook = ApiUrl.v1(UC.webHook, UC.msg91, UA.insert);

    // Misc
    static readonly getIntroVideoPath = ApiUrl.v1(UC.misc, UC.intro, UC.video, UA.get);
}

export class SystemUrlPath {
    static readonly health = ApiUrl.v1("health");
    static readonly version = ApiUrl.v1("version");
    static readonly publicHostname = ApiUrl.v1("hostname");
}
